import api from '@/api';
import makeSorter from '@/lib/makeSorter';
import { regexpSearch } from '@/lib/searchFns';
import ___ from '../constants';
import { forEach, result } from 'lodash';
import { matchesExactFields, matchesIncludeFields, subtractFields } from '../shared/searchUtilites';
import { message } from 'antd';

const dateColumns = [
    'est_arrival_date',
];

const initialState = {
    currentEditRow: null,
    locationRows: null,
    filteredRows: [],
    errors: [],
    loading: false,
    searchLoading: false,
    columns: [],
    filteredSource: [],
    searchedSource: [],
    sortOrder: false,
    sortField: false,
};

export const types = {
    SET_STATE: 'TRANSFERS/SET_STATE',
};

export const reducers = (state = initialState, action) => {
    switch (action.type) {
        case types.SET_STATE:
            return { ...state, ...action.data };
        default:
            return state;
    }
};


export const actions = {
    setState: (data) => ({ type: types.SET_STATE, data }),

    setCurrentEditRow: (row) => async (dispatch, getState) => {
        console.log('[Transfers.redux.js] setCurrentEditRow');
        console.log(row);
        dispatch({
            type: types.SET_STATE,
            data: {
                currentEditRow: row,
            },
        });
    },

    getItems: (search) => async (dispatch, getState) => {
        console.log('[Transfers.redux.js] getItems() : search', search);

        const state = getState();
        dispatch(actions.setState({ loading: true }));

        try {

            let _search = '%' + search + '%';

            // QUERY Transfer.GetTransferItems
            let exactResults = await api.get('/warehouse/item-transfers/'
                , { params: { search: search } } // not using % wildcards for exact
            );
            console.log(exactResults)

            // QUERY Transfer.GetTransferItemsSearch
            let result = await api.get('/warehouse/item-transfers-search/'
                , { params: { search: _search } }// using % wildcards for search
            );
            console.log('search result:', result)

            let exactItems = exactResults.items || [];
            let searchItems = result.items || [];

            if (!exactItems.length && !searchItems.length) {
                message.warning('No transfer items found.');
            } else {
                if (!exactItems.length) {
                    message.warning('No exact item match found.');
                }

                if (!searchItems.length) {
                    message.warning('No related transfer items found.');
                }
            }


            dispatch(actions.setState({
                transferItemsExact: exactItems,
                transferItems: searchItems,
            }));

            // give a slight delay before loading false  because it feels jarring
            setTimeout(() => {
                dispatch(actions.setState({
                    loading: false
                }));
            }
                , 500);

        } catch (err) {
            console.log('[Transfers.redux] catch err')
            console.error(err);
            const errorMsg =
                    err.response?.data?.errorMsg ||
                    err.response?.data?.message ||
                    err.response?.data?.errors?.[0] ||
                    err.message ||
                    'Could not get items';

                message.error(errorMsg);
            dispatch(actions.setState({
                transferItems: [],
                transferItemsExact: [],
                filteredRows: [],
                filteredSource: [],
                loading: false
            }));
        }
    },

    getWarehouseLocations: () => async (dispatch, getState) => {
        console.log('[Transfers.redux.js] getWarehouseLocations()');
        //dispatch(actions.setState({ loading: true }));

        try {
            // QUERY Transfer.GetWarehouses + Transfer.AllLocations
            let result = await api.get('/warehouse/all-locations/'
                // , { params: { search: _search } }
            );
            console.log(result)
            dispatch(actions.setState({
                warehouseRows: result.warehouses,
                locationRows: result.locations,
                //loading: false
            }));
        } catch (err) {
            console.log('[Transfers.redux] catch err')
            console.error(err);
            dispatch(actions.setState({
                warehouseRows: [],
                locationRows: [],
                //loading: false
            }));
        }
    },

    getLocationsWithQuantity: () => async (dispatch, getState) => {
        console.log('[Transfers.redux.js] getLocationsWithQuantity()');
        // TODO if needed
    },

    saveTransfers: (batch, popSuccessCB) => async (dispatch, getState) => {
        console.log('[Transfers.redux.js] saveTransfers()');
        console.log(batch);
        dispatch(actions.setState({ loading: true }));
        try {

            let submitTransferRows = [];
            submitTransferRows = batch.transferLines.map(xferLine => {
                // takes properties from the original editRow and adds the properties from the transferLines, which includes the new warehouse, bin, and quantity
                return {
                    ...batch,
                    ...xferLine,
                    //Comments: batch.Comments // JrnlMemo
                }
            });

            let result = await api.put('/warehouse/write-transfer',
                {
                    submitTransferRows
                });
            console.log(result);
            console.log(result.success);
            console.log(result.responses);
            console.log(result.statuses);

            if (result.success) {
                console.log('success');
                popSuccessCB(); // -OR-  popSuccessCB(result.responses[0]); // hardcoded zero index, use with popSuccessWithNum
                dispatch(actions.setState({ loading: false }));
                //dispatch(actions.getItems()); // could be refreshed here - we should discuss submit+alert behavior

            } else {
                console.warn('no success property');
                dispatch(actions.setState({ loading: false }));
            }

        } catch (err) {
            console.error((result & result.errorMsg) ? result.errorMsg : 'Could not Write');
            console.error(err);
            const errorMsg =
                    err.response?.data?.errorMsg ||
                    err.response?.data?.message ||
                    err.response?.data?.errors?.[0] ||
                    err.message ||
                    'Could not save transfers';

                message.error(errorMsg);
            dispatch(actions.setState({ loading: false }));
        }
    },

    searchCurrent: ({ searchValue = '', excludeList = [], includeList = [], exactList = [] }) => (dispatch, getState) => {
        console.log('[Transfers.redux] searchCurrent');
        console.log('searchValue', searchValue ? searchValue : 'searchValue was NULL')

        const finalIncludeList = subtractFields(includeList, excludeList, exactList);
        const finalExactList = exactList.filter(field => !excludeList.includes(field));

        dispatch(actions.setState({ searchLoading: true }));

        setTimeout(() => {
            const { filteredSource, sortOrder, sortField } = getState().warehouseProd;
            let searchedSource = [];

            if (filteredSource) {
                for (let bp of filteredSource) {
                    if (searchValue === '') {
                        searchedSource.push(bp);
                        continue;
                    }

                    const matchedInclude = matchesIncludeFields(bp, finalIncludeList, searchValue);
                    const matchedExact = matchesExactFields(bp, finalExactList, searchValue);

                    if (matchedInclude || matchedExact) {
                        searchedSource.push(bp);
                    }
                }
            } else {
                console.error('filteredSource falsey')
                // console.error(filteredSource)
            }
            dispatch(actions.setState({
                searchedSource: [...searchedSource],
                searchValue,
                hasFilterBeenApplied: true,
                hasOrder: true,
            }));

            dispatch(actions.sortCurrent({
                field: sortField,
                order: sortOrder
            }));

            dispatch(actions.setState({ searchLoading: false }));
        }, 1000); // 1 second delay
    },

    sortCurrent: ({ field, order }) => (dispatch, getState) => {
        // console.log('[Transfers.redux] sortCurrent ')
        // console.log(field)
        // console.log(order)
        let { searchedSource, columns } = getState().warehouseProd;

        const numberSortColumns = [
            ...dateColumns,
            'card_code',
        ];

        let newColumns = columns.map((col) => {
            if (col.dataIndex === field) {
                return { ...col, sortOrder: order }
            } else {
                return { ...col, sortOrder: false }
            }
        });

        let _searchedSource = searchedSource;

        if (field !== false) {
            let type = 'string';
            if (numberSortColumns.indexOf(field) !== -1) {
                type = 'number';
            }
            _searchedSource = searchedSource.sort(makeSorter(type, field));
        }

        if (order === 'ascend') {
            _searchedSource = _searchedSource.reverse();
        }

        dispatch(actions.setState({
            columns: newColumns,
            filteredRows: [..._searchedSource],
            sortOrder: order,
            sortField: field,
        }));
    },

};
